import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { TEXT_COLOR } from "../../theme";
import { IconButton, Tooltip, Typography } from "@mui/material";
import { styles } from "./ShareAnalyticsModalStyles";
import { Props } from "./types";
import CloseIcon from "@mui/icons-material/Close";

export const ShareAnalyticsModal: React.FC<Props> = ({
  open,
  setOpen,
  selectedShareForAnalytics,
}) => {
  const getTimestampToDate = (timeStamp: number, isExpiryTime?: boolean) => {
    const date = isExpiryTime
      ? new Date(timeStamp)
      : new Date(timeStamp * 1000);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const amPm = hours >= 12 ? "PM" : "AM";
    const formattedHours = (hours % 12 || 12).toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");
    return `${month}/${day}/${year} ${formattedHours}:${formattedMinutes} ${amPm}`;
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styles.mainContainer}>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Typography
            variant="h4"
            sx={{ color: TEXT_COLOR, fontWeight: "bold", marginBottom: "10px" }}
          >
            {selectedShareForAnalytics?.getShare()?.getTrackTitle()}
          </Typography>
          <Typography sx={{ color: TEXT_COLOR }}>
            Total Views:{" "}
            {selectedShareForAnalytics?.getShare()?.getImpressionCount()}
            <Tooltip
              placement="top"
              title="Total views count after 3 seconds of playback."
            >
              <span style={styles.infoCircle}>i</span>
            </Tooltip>
          </Typography>
          <Typography sx={{ color: TEXT_COLOR }}>
            Max Views:{" "}
            {selectedShareForAnalytics?.getShare()?.getUnlimitedViews()
              ? "Unlimited"
              : selectedShareForAnalytics?.getShare()?.getMaxViews()}
          </Typography>
          <Typography sx={{ color: TEXT_COLOR }}>
            Expiry Time:
            {selectedShareForAnalytics?.getShare()?.getExpiryTimestamp() !==
            undefined
              ? " " +
                getTimestampToDate(
                  selectedShareForAnalytics?.getShare()!.getExpiryTimestamp(),
                  true
                )
              : "No Expiry Date"}
          </Typography>
          <Box>
            {selectedShareForAnalytics &&
              selectedShareForAnalytics.getShareAnalyticsList().length > 0 && (
                <Box sx={styles.tableOuterContainer}>
                  <Box sx={styles.tableMainContainer}>
                    <Box sx={styles.countryContainer}>Country</Box>
                    <Box sx={styles.ipContainer}>IP</Box>
                    <Box sx={styles.countryContainer}>Type</Box>
                    <Box sx={styles.countryContainer}>UserName</Box>
                    <Box sx={styles.countryContainer}>Date</Box>
                  </Box>
                  {selectedShareForAnalytics
                    ?.getShareAnalyticsList()
                    .map((e) => {
                      return (
                        <Box
                          key={e.getId()}
                          sx={{
                            ...styles.tableMainContainer,
                            ...{ marginTop: 0 },
                          }}
                        >
                          <Box sx={styles.countryContainer}>
                            {e.getCountry()}
                          </Box>
                          <Box sx={styles.ipContainer}>{e.getIp()}</Box>
                          <Box sx={styles.countryContainer}>{e.getType()}</Box>
                          <Box sx={styles.countryContainer}>
                            {e.getOmmuseUsername()}
                          </Box>
                          <Box sx={styles.countryContainer}>
                            {getTimestampToDate(e.getTimestamp(), true)}
                          </Box>
                        </Box>
                      );
                    })}
                </Box>
              )}
          </Box>
        </Box>
      </Modal>
    </div>
  );
};
